// src/pages/Index.tsx
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import About from '../components/About';
import MenuComponent from '../components/Menu';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const Index = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <About />
      <MenuComponent />
      <Contact />
      <Footer />
    </div>
  );
};

export default Index;